import React from "react";
import "./JobCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const JobCard = ({
  job,
  imageUrl,
  onSave,
  onApply,
}) => {
  return (
    <div className="job-card-component">
      <div className="card unique-job-card-spec shadow-sm">
        <div className="card-body p-3 d-flex align-items-start gap-2 gap-md-3">

          <input
            type="checkbox"
            className="form-check-input modular-job-checkbox mt-1"
            id={`job-check-${job?.id}`}
          />

          <div className="flex-grow-1 info-block-container">

            <div className="d-flex justify-content-between align-items-start header-row-wrap">

              <div>

                <h4 className="job-title-main m-0">
                  {job?.role?.name?.toLowerCase().includes("python") ? (
                    <>
                      {job?.role?.name?.split(/python/i)[0]}
                      <mark className="highlight-text-yellow">
                        Python
                      </mark>
                      {job?.role?.name?.split(/python/i)[1]}
                    </>
                  ) : (
                    job?.role?.name || "Job Title"
                  )}
                </h4>

                <p className="company-subtitle-text mt-1 mb-2">
                  {job?.company_name || "Company Confidential"}
                </p>

              </div>

              <div className="brand-logo-avatar-box">

                {job?.job_contact?.logo ? (
                  <img
                    src={imageUrl + job?.job_contact?.logo}
                    className="visual-logo-img"
                    alt="logo"
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                ) : (
                  <div className="letter-fallback-avatar">
                    {job?.company_name
                      ? job.company_name.charAt(0).toUpperCase()
                      : "J"}
                  </div>
                )}

              </div>

            </div>

            <div className="d-flex flex-wrap align-items-center text-muted metadata-row gap-3 mb-2">

              <span className="metadata-item-element">
                <FontAwesomeIcon
                  icon="fa-solid fa-briefcase"
                  className="me-1 grey-icon"
                />
                {job?.experience || "0-2"} yrs
              </span>

              <span className="metadata-item-element">
                <FontAwesomeIcon
                  icon="fa-solid fa-location-dot"
                  className="me-1 grey-icon"
                />
                {job?.city || "India"}
              </span>

            </div>

            <div className="skills-line-row mb-1">

              <span className="bold-prefix-label">
                Skills:
              </span>

              <span className="skills-comma-string text-muted">

                {job?.skills?.toLowerCase().includes("python") ? (
                  <>
                    {job?.skills?.split(/python/i)[0]}
                    <mark className="highlight-text-yellow">
                      Python
                    </mark>
                    {job?.skills?.split(/python/i)[1]}
                  </>
                ) : (
                  job?.skills
                )}

              </span>

            </div>

            <div className="skills-line-row mb-3">

              <span className="bold-prefix-label">
                In JD:
              </span>

              <mark className="highlight-text-yellow">
                Python
              </mark>

              {job?.role?.name?.toLowerCase().includes("django") && (
                <mark className="highlight-text-blue ms-1">
                  Django
                </mark>
              )}

            </div>

            <div className="mb-2">
              <span className="early-applicant-pill-badge">
                <FontAwesomeIcon
                  icon="fa-solid fa-clock"
                  className="me-1"
                />
                Early Applicant
              </span>
            </div>

            <div className="d-flex justify-content-between align-items-center card-bottom-actions border-top pt-3 mt-2">

              <span className="time-posted-lbl">
                Posted 14 hours ago
              </span>

              <div className="d-flex gap-2">

                <button
                  className="btn btn-save-action shadow-sm px-2 px-md-3"
                  onClick={() => onSave(job)}
                >
                  <FontAwesomeIcon
                    icon="fa-solid fa-bookmark"
                    className="me-1"
                  />
                  Save
                </button>

                <button
                  className="btn btn-quick-apply shadow-sm px-2 px-md-3"
                  onClick={() => onApply(job)}
                >
                  <FontAwesomeIcon
                    icon="fa-solid fa-bolt"
                    className="me-1"
                  />
                  Quick Apply
                </button>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default JobCard;